module.exports = __webpack_public_path__ + "static/media/unit-1000.e63332fd.svg";